module.exports = __webpack_public_path__ + "img/random.1b992e37.png";